import React from "react";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/effect-fade";
import { Container } from "react-bootstrap";
import Image from "next/image";
const testimonials = [
  {
    id: 1,
    title: "Tushar Kumar Das - Proud Owner from College Street",
    image: "/images/gallery/testimonial/1.jpg",
    videolink: "https://www.youtube.com/embed/uxSBy53rB3o",
  },
  {
    id: 2,
    title:
      "Real Estate Testimonial - Ganga Facing Flats in Serampore, North Kolkata",
    image: "/images/riverside_testimonial/2.jpg",
    videolink: "https://www.youtube.com/embed/rEVjlTENtPo",
  },
  {
    id: 3,
    title: "Testimonial by Susmita Mitra - New Kolkata #RiversideProject",
    image: "/images/riverside_testimonial/3.jpg",
    videolink: "https://www.youtube.com/embed/qHqbHmFN9q4",
  },
  {
    id: 4,
    title: "Why to Choose New Kolkata #RiversideProject? - Narendra Chouhan",
    image: "/images/riverside_testimonial/4.jpg",
    videolink: "https://www.youtube.com/embed/aP0tUigAh2Q",
  },
  {
    id: 5,
    title: "New Kolkata Riverside Project - a Mariner's Choice",
    image: "/images/riverside_testimonial/5.jpg",
    videolink: "https://www.youtube.com/embed/31URcf0e3LQ",
  },
  {
    id: 6,
    title:
      "New Kolkata Riverside Project - Reasons to Choose - Dr. Susruta Das",
    image: "/images/riverside_testimonial/6.jpg",
    videolink: "https://www.youtube.com/embed/p9OhaoYII3Q",
  },
  {
    id: 7,
    title: "Feedback from a Retired Person - New Kolkata Riverside",
    image: "/images/riverside_testimonial/7.jpg",
    videolink: "https://www.youtube.com/embed/595HfKfX4lI",
  },
  {
    id: 8,
    title: "New Kolkata #RiversideApartment - Rakesh Das",
    image: "/images/riverside_testimonial/8.jpg",
    videolink: "https://www.youtube.com/embed/9aXejeqj5dA",
  },
  {
    id: 9,
    title: "Kolkata Riverside Apartment Booked by Ravikant Singh from Odissa",
    image: "/images/riverside_testimonial/9.jpg",
    videolink: "https://www.youtube.com/embed/MMJTVXjPgYc",
  },
  {
    id: 10,
    title: "Next Proud Owner of this Riverside Project - New Kolkata",
    image: "/images/riverside_testimonial/10.jpg",
    videolink: "https://www.youtube.com/embed/tgDFxHqMmvs",
  },
  {
    id: 11,
    title: "A Proud Owner of New Kolkata Riverside Project",
    image: "/images/riverside_testimonial/11.jpg",
    videolink: "https://www.youtube.com/embed/0QnoM84LRbc",
  },
  {
    id: 12,
    title: "A Proud Owner of New Kolkata from Jamshedpur",
    image: "/images/riverside_testimonial/12.jpg",
    videolink: "https://www.youtube.com/embed/tqLWTnu6MaQ",
  },
  {
    id: 13,
    title: "Proud Owner of New Kolkata Riverside Flats from Mumbai",
    image: "/images/riverside_testimonial/13.jpg",
    videolink: "https://www.youtube.com/embed/pV35Bx2rlEQ",
  },
  {
    id: 14,
    title: "Another Proud Owner of New Kolkata from Baidyabati",
    image: "/images/riverside_testimonial/14.jpg",
    videolink: "https://www.youtube.com/embed/POfEvp720EI",
  },
  {
    id: 15,
    title: "A Proud Owner of New Kolkata from Asansole",
    image: "/images/riverside_testimonial/15.jpg",
    videolink: "https://www.youtube.com/embed/_7MHGTq5iO4",
  },
];
const RiversideTestimonial = () => {
  return (
    <>
      <section className="gallery video sec-padd">
        <Container>
          <div
            className="head_wrap"
            data-aos="fade-up"
            data-aos-delay="300"
            data-aos-duration="1000"
          >
            <div className="center-title text-center">
              <h3 className="section-title">TESTIMONIALS</h3>
            </div>
          </div>
          <div className="mt-30">
            <Swiper
              modules={[Autoplay, Navigation]}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              navigation={{
                nextEl: ".cust-swiper-button-next",
                prevEl: ".cust-swiper-button-prev",
              }}
              loop={true}
              speed={1200}
              className="cust_slider"
              breakpoints={{
                767: {
                  slidesPerView: 1,
                  spaceBetween: 24,
                },
                992: {
                  slidesPerView: 2,
                  spaceBetween: 24,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 24,
                },
              }}
            >
              {testimonials &&
                testimonials.map((item) => {
                  return (
                    <SwiperSlide key={item.id}>
                      <div className="img-wrap image-container gall_wrp">
                        <div
                          data-fancybox="construction"
                          data-src={item.videolink}
                          className="img_overlay"
                        >
                          <Image
                            fill
                            src={item.image}
                            alt="interior"
                            className="image"
                          />
                        </div>
                      </div>
                      <p className="mt-2 text-center mb-0">{item.title}</p>
                    </SwiperSlide>
                  );
                })}

              <div className="swiper-nav mt-4">
                <button className="fa-solid fa-chevron-left cust-swiper-button-prev">
                  <span>prev</span>
                </button>
                <button className="fa-solid fa-chevron-right cust-swiper-button-next">
                  <span>next</span>
                </button>
              </div>
            </Swiper>
          </div>
        </Container>
      </section>
    </>
  );
};

export default RiversideTestimonial;
